import React, { useState, useEffect } from 'react';
import './Mine.css';
import { 
  Wallet, ArrowDownCircle, ArrowUpCircle, History, 
  ChevronRight, UserCircle, CreditCard, Settings as SettingsIcon
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase'; 
import { ref, onValue } from "firebase/database"; 
import Loader from '../components/Loader'; 
import { useTranslation } from 'react-i18next'; // Hook import kiya

const Mine = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(); // Translation function initialization
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (!savedUser) {
      navigate('/login');
      return;
    }

    const initialUser = JSON.parse(savedUser);
    const userRef = ref(db, 'users/' + initialUser.username);
    
    const unsubscribe = onValue(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const liveData = snapshot.val();
        setUser(liveData);
        localStorage.setItem('user', JSON.stringify(liveData));
      }
      setLoading(false); 
    });

    return () => unsubscribe(); 
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    window.location.href = "/login";
  };

  const formatBalance = (amount) => {
    return parseFloat(amount || 0).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  return (
    <div className="mine-wrapper">
      {loading && <Loader />}

      <div className="mine-header">
        <div className="profile-section" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: '20px', gap: '15px' }}>
          <div className="avatar-icon-box">
            <UserCircle size={58} strokeWidth={1.5} color="#f3ba2f" />
          </div>
          
          <div className="user-details" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700' }}>{user?.username || '---'}</h3>
            <p style={{ margin: '2px 0 0 0', color: '#666', fontSize: '13px' }}>{user?.email || '---'}</p>
          </div>
        </div>
      </div>

      <div className="balance-card">
        <div className="balance-label">{t('total_balance')}</div>
        <div className="main-amount">
          {formatBalance(user?.balance)} <span style={{ fontSize: '16px', fontWeight: '500' }}>USDT</span>
        </div>
        
        <div className="card-actions">
          <button className="btn-main deposit" onClick={() => navigate('/deposit', { state: { from: 'mine' } })}>
            <ArrowDownCircle size={18} /> {t('deposit')}
          </button>
          <button className="btn-main withdraw" onClick={() => navigate('/withdraw')}>
            <ArrowUpCircle size={18} /> {t('withdraw')}
          </button>
        </div>
      </div>

      <div className="menu-container">
        <div className="menu-row" onClick={() => navigate('/recharge-history')}>
          <div className="menu-left">
            <div className="icon-box gold-bg"><History size={18} /></div>
            <span>{t('recharge_history')}</span>
          </div>
          <ChevronRight size={16} className="chevron" />
        </div>

        <div className="menu-row" onClick={() => navigate('/withdrawal-history')}>
          <div className="menu-left">
            <div className="icon-box blue-bg"><CreditCard size={18} /></div>
            <span>{t('withdrawal_history')}</span>
          </div>
          <ChevronRight size={16} className="chevron" />
        </div>

        <div className="menu-row" onClick={() => navigate('/payment-method')}>
          <div className="menu-left">
            <div className="icon-box gold-bg"><Wallet size={18} /></div>
            <span>{t('wallet')}</span>
          </div>
          <ChevronRight size={16} className="chevron" />
        </div>

        {/* Settings Row */}
        <div className="menu-row" onClick={() => navigate('/settings')}>
          <div className="menu-left">
            <div className="icon-box blue-bg"><SettingsIcon size={18} /></div>
            <span>{t('settings')}</span>
          </div>
          <ChevronRight size={16} className="chevron" />
        </div>
      </div>

      <button className="logout-action" onClick={handleLogout}>{t('log_out')}</button>
    </div>
  );
};

export default Mine;